import { render, staticRenderFns } from "./arquivo.vue?vue&type=template&id=22407fba&scoped=true"
import script from "./arquivo.vue?vue&type=script&lang=js"
export * from "./arquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22407fba",
  null
  
)

export default component.exports